import { render, staticRenderFns } from "./rating-stars.vue?vue&type=template&id=15933248&"
import script from "./rating-stars.vue?vue&type=script&lang=js&"
export * from "./rating-stars.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\OSPanel\\domains\\specialty.local\\local\\js\\specialty\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15933248')) {
      api.createRecord('15933248', component.options)
    } else {
      api.reload('15933248', component.options)
    }
    module.hot.accept("./rating-stars.vue?vue&type=template&id=15933248&", function () {
      api.rerender('15933248', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/common/rating-stars.vue"
export default component.exports